import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Stack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Flex,
  useToast,
  Textarea,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { MdReportProblem } from "react-icons/md";

import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";
import useStore from "@/store";
import CardImage from "./CardImage";
import { useTranslation } from "react-i18next";

const schema = yup
  .object()
  .shape({
    details: yup.string().required("report.field_required"),
  })
  .required();

export default function Report({ id, itemId, original }) {
  const { t } = useTranslation("orders");

  const reportOrder = useStore(state => state.reportOrder);
  const reportItemOrder = useStore(state => state.reportItemOrder);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: yupResolver(schema) });

  async function onSubmit(values, e) {
    e.preventDefault();
    if (itemId) {
      const res = await reportItemOrder(id, values.details, itemId);
      if (res?.status === 202) {
        toast({
          isClosable: true,
          title: t("report.operation_successful"),
          status: "success",
          duration: 3000,
        });

        onClose();
        reset();
      } else {
        toast({
          isClosable: true,
          title: res?.data?.message || t("report.error_occurred"),
          status: "error",
          duration: 3000,
        });
      }
    } else {
      const res = await reportOrder(id, values.details, itemId);

      if (res?.status === 202) {
        toast({
          isClosable: true,
          title: t("report.operation_successful"),
          status: "success",
          duration: 3000,
        });

        onClose();
        reset();
      } else {
        toast({
          isClosable: true,
          title: res?.data?.message || t("report.error_occurred"),
          status: "error",
          duration: 3000,
        });
      }
    }
  }
  return (
    <>
      <Button colorScheme="orange" size="sm" onClick={onOpen}>
        <MdReportProblem />
      </Button>

      <Modal size="lg" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t("report.report_issue")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={4}>
                <FormControl isInvalid={errors.details}>
                  {original?.itemProductName && (
                    <>
                      <FormLabel>
                        {t("report.card_number", {
                          code: original?.itemCode,
                        })}
                      </FormLabel>
                      <FormLabel>
                        {t("report.before_sending_report")}
                        <CardImage serial={original?.itemCode} />
                      </FormLabel>
                      <FormLabel>{t("report.compare_and_correct")}</FormLabel>
                      <FormLabel>{t("report.contact_support")}</FormLabel>
                    </>
                  )}

                  <FormLabel>{t("report.details")}</FormLabel>
                  <Textarea
                    placeholder={t("report.details")}
                    {...register("details")}
                  />

                  <FormErrorMessage>
                    {errors.details && t(errors.details.message)}
                  </FormErrorMessage>
                </FormControl>
              </Stack>
              <Flex my="8" justify="flex-end">
                <Button variant="ghost" mr={3} onClick={onClose}>
                  {t("report.cancel")}
                </Button>
                <Button
                  type="submit"
                  isLoading={isSubmitting}
                  isDisabled={isSubmitting}
                  colorScheme="green"
                >
                  {t("report.report")}
                </Button>
              </Flex>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
